import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ImageModule } from '@df/module-image/image.module';
import { BgColorOptions, ColorOptions, HtmlTagOptions } from '@df/ui/atomic/atomic-options';
import { HrefComponent } from '@df/ui/common/href/href.component';
import { ShellComponent } from '@df/ui/common/shell/shell.component';
import { SizeClassDirective } from '@df/ui/common/size-class.directive';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { defaultImage } from 'projects/app-default/src/app/icms.config';
import { ShopThisLookComponent } from 'projects/app-default/src/app/ui/shop-this-look/shop-this-look.component';
import { NShopThisLook } from 'projects/app-default/src/app/ui/shop-this-look/shop-this-look.interface';
import { ReadMoreComponent } from '../../../display/read-more/read-more.component';

export interface IPageComponentCategoryLandingPageHeaderData extends NICmsContentComponent.IData, NShopThisLook.IData {
    title: string;
    titleTag?: string;
    copy?: string;
    image: string;
    link?: string;
    background_color?: string;
    button_white?: boolean;
    text_color?: string;
}
@ICmsComponent<PageComponentCategoryLandingPageHeaderComponent>({
    id: 'category-landing-page-header',
    name: 'Category landing page header',
    tags: ['listing', 'category', 'header'],
    fields: [
        {
            type: NICmsContentField.EFieldType.text,
            key: 'title',
            title: 'Title',
            required: true,
            default: '<h1>Shop by Discipline'
        },
        <NICmsContentField.IChoiceField>{
            key: 'titleTag',
            type: NICmsContentField.EFieldType.choice,
            title: 'Title HTML tag',
            description: 'For SEO reasons you may want to force particular HTML tag',
            options: HtmlTagOptions,
            default: 'h1'
        },
        {
            type: NICmsContentField.EFieldType.text,
            key: 'copy',
            title: 'Copy',
            default:
                'A wide range of products for horse and rider designed for optimum comfort and performance in your chosen discipline. Browse the collections to make sure you have everything you need for training and your next competition'
        },
        {
            type: NICmsContentField.EFieldType.image,
            key: 'image',
            title: 'Image',
            required: true,
            default: defaultImage
        },
        {
            key: 'link',
            type: NICmsContentField.EFieldType.text,
            title: 'Link'
        },
        {
            type: NICmsContentField.EFieldType.toggle,
            key: 'button_white',
            title: 'White `Read more` button',
            default: false
        },
        <NICmsContentField.IChoiceField>{
            type: NICmsContentField.EFieldType.choice,
            key: 'background_color',
            title: 'Background color',
            options: BgColorOptions,
            previewMode: 'color'
        },
        <NICmsContentField.IChoiceField>{
            type: NICmsContentField.EFieldType.choice,
            key: 'text_color',
            title: 'Text color',
            options: ColorOptions,
            previewMode: 'color'
        },
        ...NShopThisLook.fields
    ]
})
@Component({
    selector: 'page-component-category-landing-page-header',
    templateUrl: 'category-landing-page-header.html',
    standalone: true,
    imports: [
        HrefComponent,
        ICmsClientModule,
        ImageModule,
        NgClass,
        ReadMoreComponent,
        ShellComponent,
        ShopThisLookComponent,
        SizeClassDirective
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PageComponentCategoryLandingPageHeaderComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'component'
    })
    component!: IPageComponentCategoryLandingPageHeaderData;
}
